import axios, { AxiosRequestConfig } from "axios";

const BASE_URL = process.env.REACT_APP_API_URL as string;

// Auto-detect multipart for FormData
const getConfig = (body: any, config: AxiosRequestConfig = {}): AxiosRequestConfig => {
  if (body instanceof FormData) {
    return {
      ...config,
      headers: {
        "Content-Type": "multipart/form-data",
        ...config.headers,
      },
    };
  }
  return config;
};

// GET
export const GetApiMethod = (routeName: string, config: AxiosRequestConfig = {}) => {
  return axios.get(`${BASE_URL}/${routeName}`, config);
};

// POST
export const PostApiMethod = (routeName: string, body: any, config: AxiosRequestConfig = {}) => {
  return axios.post(`${BASE_URL}/${routeName}`, body, getConfig(body, config));
};

// PUT
export const PutApiMethod = (routeName: string, body: any, config: AxiosRequestConfig = {}) => {
  return axios.put(`${BASE_URL}/${routeName}`, body, getConfig(body, config));
};

// DELETE
export const DeleteApiMethod = (routeName: string, config: AxiosRequestConfig = {}) => {
  return axios.delete(`${BASE_URL}/${routeName}`, config);
};

// PATCH
export const PatchApiMethod = (routeName: string, body: any = {}, config: AxiosRequestConfig = {}) => {
  return axios.patch(`${BASE_URL}/${routeName}`, body, getConfig(body, config));
};
